/** Shared defaults for procedural map-gen stamp / zone placement. */

/** Default zone-boundary jitter as a fraction of surplus slack. */
export const MAP_GEN_ZONE_JITTER_FRACTION = 0.3;
